module.exports = __webpack_public_path__ + "static/media/Kemper.729a22ed.webp";